import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import "../../../styles/lead-mangement/lms-closure-report.css";
import { closureTabList } from "./ClosureReportMocks";
import GSPD from "./pipeline-dashboard/GSPD";
import PipelineTracker from "./pipeline-tracker/PipelineTracker";
// import GymLMS from "./gym-lms/GymLMS";
import AgentManagement from "./agent-management/AgentManagement";
import PageHeadingNew from "../../common-components/custom-comps/PageHeadingNew";
// import AnalyticsReports from "./analytics-reports/AnalyticsReports";
// import ClosureTrackingDetection from "./closure-tracking-detection/ClosureTrackingDetection";
// import SalesPipeline from "./sales-pipeline/SalesPipeline";

const LMSClosureStructure = ({ userInfoData }) => {
  const [activeTab, setActiveTab] = useState("gym_sales_pipeline_dashboard");

  return (
    <>
      <Row>
        <Col>
        <div className="lms-closure-gyms-header">
        <PageHeadingNew
          heading="LMS Closure Report"
        />
         </div>

          <div className="lms-v2-tabs-container lms-closure-report-tabs">
            {closureTabList?.map((tab, idx) => {
              const IconComponent = tab?.icon;
              return (
                <div
                  key={tab.id}
                  className={`lms-v2-tab ${
                    activeTab === tab?.id ? "lms-v2-tab-active" : ""
                  }`}
                  onClick={() => setActiveTab(tab?.id)}
                  style={{ cursor: "pointer" }}
                >
                  {IconComponent && <IconComponent />}
                  <span style={{ marginLeft: "8px" }}>
                    {tab?.label?.replace(/_/g, " ")}
                  </span>
                </div>
              );
            })}
          </div>

          {activeTab === "gym_sales_pipeline_dashboard" && (
            <GSPD userInfoData={userInfoData} />
          )}

          {activeTab === "pipeline_tracker" && (
            <PipelineTracker userInfoData={userInfoData} />
          )}

          {/* {activeTab === "gym_lead_management" && (
            <GymLMS userInfoData={userInfoData} />
          )} */}

          {activeTab === "agent_management" && (
            <AgentManagement userInfoData={userInfoData} />
          )}

          {/* {activeTab === "analytics_&_reports" && (
            <AnalyticsReports userInfoData={userInfoData} />
          )}
           */}
          {/* {activeTab === "closure_tracking_&_detection" && (
            <ClosureTrackingDetection userInfoData={userInfoData} />
          )} */}

          {/* {activeTab === "sales_pipeline" && (
            <SalesPipeline userInfoData={userInfoData} />
          )} */}
        </Col>
      </Row>
    </>
  );
};

export default LMSClosureStructure;
